import styled from 'styled-components';
import { Layout } from 'antd';
import { Link as RouterLink } from 'react-router-dom'
import { Button as StyledButton } from '../../styles/buttons'

export const Container = styled(Layout)`
  padding: 0.5rem 1rem;
  gap: 1rem;
  position: relative;

  @media (min-width: 768px) {
    padding: 1rem 2rem;
  }
`;

export const TableContainer = styled.div``;

export const Button = styled(StyledButton)`
  width: unset;
  margin-top: 0;
  align-self: flex-end;
  border-radius: 20px;
`;

export const Link = styled(RouterLink)``;

export const ResponsiveTable = styled.div`
`;

export const ResponsiveRow = styled.div`
  display: flex;
  margin: 0 12px 12px 0;
  justify-content: space-between;

  text-align: center;
  align-items: center;
  align-content: space-between;

  border-radius: 8px;

  @media (min-width: 769px) {
    display: none;
  }
`;

export const ResponsiveColumn = styled.div`
  text-align: center;
  word-wrap: break-word;
  font-size: 12px;
  max-width: 30%;

  padding: 7px 9px 7px 9px;
`;

export const ResponsiveTableTitle = styled.div`
  font-weight: bold;
  display: flex;
  align-content: space-around;
  justify-content: space-between;
  padding-left: 30px;

`;
